const routes = {
  ROUTE_REDEEM_CAMPAIGN: '/campaign/:code',
  ROUTE_REDEEM_REWARD: '/reward/:code',
  POST_HELLO: 'public/info',
  ROUTE_NOT_FOUND: '/not_found',
}

export default routes
